export default {
  familyName: 'Barlow',
  fullName: 'Barlow Bold',
  postscriptName: 'Barlow-Bold',
  category: 'sans-serif',
  capHeight: 700,
  ascent: 1000,
  descent: -200,
  lineGap: 0,
  unitsPerEm: 1000,
  xHeight: 514,
  xWidthAvg: 444,
  subsets: {
    latin: {
      xWidthAvg: 444
    },
    thai: {
      xWidthAvg: 474
    }
  }
};
